module.exports = __webpack_public_path__ + "images/emails/logo-newsberry-f25226fb.png";